import { createContentPropTypes } from '../../helpers/content';

export const declineContent = {
	noPaymentsAccountButtonText: 'Go to your accounts',
	noPaymentsCloseButtonText: 'Check payment status',
	noPaymentsHeaderText: 'All Done',
	noPaymentsSubHeaderText: 'You haven`t got any other payments to authorise right now',
	processedHeaderText: 'This payment`s been declined',
	processedHeaderTextBatch: 'These payments have been successfully declined.',
	processedSubHeaderText:
		'Because you chose not to provide authorisation, this payment will not be made and no money will leave this account.',
	processedButtonText: 'Ok',
	promptHeaderText: 'Are you sure you want to decline this payment?',
	promptSubHeaderText: 'If you decline this payment, it won’t be made and no money will leave this account.',
	promptYesButtonText: 'Yes, decline payment',
	promptNoButtonText: 'No, go back',
};

export const cancelContent = {
	noPaymentsAccountButtonText: 'Go to your accounts',
	noPaymentsCloseButtonText: 'Check payment status',
	noPaymentsHeaderText: 'All Done',
	noPaymentsSubHeaderText: 'You haven`t got any other payments to authorise right now',
	processedHeaderText: 'This payment`s been cancelled',
	processedHeaderTextBatch: 'These payments have been successfully cancelled.',
	processedSubHeaderText:
		'Because you chose not to provide authorisation, this payment won’t be made and no money will leave this account..',
	processedButtonText: 'Ok',
	promptHeaderText: 'Are you sure you want to cancel this payment?',
	promptSubHeaderText:
		'This payment has been submitted and is currently awaiting authorisation. If you cancel it now, the payment won’t be made and no money will leave this account.',
	promptYesButtonText: 'Yes, cancel payment',
	promptNoButtonText: 'No, go back',
};

export const contentPropTypes = createContentPropTypes(declineContent);
